// ProfileScoreCard.jsx
import React, { useState } from 'react';
import { Card, ProgressBar } from 'react-bootstrap';
import './ProfileScoreCard.css';
import WorkExperienceModal from '../Common_profile_details_modals/WorkExperienceModal/WorkExperienceModal';
import BasicDetailsModal from '../Common_profile_details_modals/BasicDetailsModal/BasicDetailsModal';

const ProfileScoreCard = () => {
    // --- Work Experience Modal State ---
  const [showWorkModal, setShowWorkModal] = useState(false);
  const handleOpenWorkModal = () => {
    setShowWorkModal(true); // Open WorkExperienceModal
  };

  const handleCloseWorkModal = () => {
    setShowWorkModal(false);
  };

    const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  return (
    <>
    <Card className="score-card">
      <Card.Body className="score-card__body">
        <div className="score-card__radial-group">
          <div className="score-card__meter">
            <span className="score-card__percentage">81%</span>
          </div>
          <div className="score-card__status">
            <h4 className="score-card__title">Profile score</h4>
            <p className="score-card__subtitle">Recruiters seek 100% profiles</p>
          </div>
        </div>

        <hr className="score-card__divider" />

        <h5 className="score-card__action-heading">Pending action</h5>
        <div className="score-card__action-item">
          <span className="score-card__action-text">Add Industry</span>
          <div>

          <span className="score-card__badge">+10%</span>
           <span className="summary-card__edit-icon" onClick={handleOpenWorkModal}>➡️</span>
          </div>
        </div>
        <div className="score-card__action-item">
          <span className="score-card__action-text">Gender</span>
          <div>

          <span className="score-card__badge">+4%</span>
           <span className="summary-card__edit-icon"   onClick={handleOpenModal}>➡️</span>
          </div>
        </div>

         <div className="score-card__action-item">
          <span className="score-card__action-text">Profile Picture</span>
          <div>

          <span className="score-card__badge">+5%</span>
           <span className="summary-card__edit-icon"   onClick={handleOpenModal}>➡️</span>
          </div>
        </div>
      </Card.Body>
    </Card>

     <WorkExperienceModal
        show={showWorkModal}
        handleClose={handleCloseWorkModal}
      />

       <BasicDetailsModal show={showModal} handleClose={handleCloseModal} />
    </>
  );
};

export default ProfileScoreCard;